import { SET_PALETTE_TYPE } from '../constants/actionTypes'

export const setPaletteType = paletteType => ({
  type: SET_PALETTE_TYPE,
  paletteType
})
